//#region src/extensions/heading-extension/text-level-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e[e.Default = 0] = "Default", e[e.H2 = 2] = "H2", e[e.H3 = 3] = "H3", e[e.H4 = 4] = "H4", e;
}({});
//#endregion
export { e as TextLevelEnum };
